import Vue from 'vue';
import PerkSearch from 'components/workperks/PerkSearch.vue';
import Notification from 'components/workperks/Notification.vue';
import HorizontalList from 'components/workperks/HorizontalList.vue';
import analyticsService from 'lib/workperks/services/AnalyticsService';
import { getBrowserInfo, navigateToUrl } from "lib/Utilities";
import { CategoryTrackingElement } from 'lib/workperks/models/Analytics';
import clickOutside from 'lib/workperks/directives/clickOutside';
export default new Vue({
    el: '#workperks-nav',
    data() {
        return {
            isMobileMenuOpen: false,
            isUserWidgetOpen: false,
            user: window.s.user,
            site: window.s.site,
            locationName: '',
            supportUrl: '',
            browser: '',
            locale: window.l.locale
        };
    },
    created() {
        this.supportUrl = this.locale === 'fr' ?
            new URL('https://www.venngo.com/fr/contact-support') :
            new URL('https://www.venngo.com/contact-support?hsCtaTracking=2ccdb1c2-4c96-4993-ae82-d6c63faae428%7C4a660646-ab5a-4b28-80ce-9e43c4c37946');
        const browserInfo = getBrowserInfo;
        this.browser = {
            'currentUrl': this.currentUrl,
            'browserName': browserInfo.name,
            'browserVersion': browserInfo.version,
            'operatingSystem': browserInfo.os,
        };
    },
    mounted() {
        var _a, _b, _c;
        this.locationName = ((_a = this.primaryLocation) === null || _a === void 0 ? void 0 : _a.label) ||
            ((_b = this.primaryLocation) === null || _b === void 0 ? void 0 : _b.province) ||
            ((_c = this.primaryLocation) === null || _c === void 0 ? void 0 : _c.country);
        this.constructSupportLink();
        document.addEventListener('keydown', this.handleKeyDown);
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleKeyDown);
    },
    computed: {
        suggestUrl() {
            const { site, user } = window.s;
            const url = this.locale === 'fr' ?
                new URL('https://survey.hsforms.com/1MZ5EHSPaQcaNIf1p-QeCfA4qs0p') :
                new URL('https://survey.hsforms.com/1kiQCBjgNTha8echMByJJnA4qs0p');
            url.searchParams.set('email', user.email);
            return `${url}&venngo_suggested_program_name=${site.name}`;
        }
    },
    methods: {
        categoryWasSelected(item) {
            analyticsService.setTemplateId(null).trackCategoryClick(item.id, CategoryTrackingElement.Menu);
            navigateToUrl(`/category/${item.id}`);
        },
        toggleMobileMenu() {
            this.isMobileMenuOpen = !this.isMobileMenuOpen;
            document.querySelector('body').classList.toggle('mobile-menu-open');
        },
        toggleUserWidget() {
            this.isUserWidgetOpen = !this.isUserWidgetOpen;
        },
        closeUserWidget() {
            this.isUserWidgetOpen = false;
        },
        constructSupportLink() {
            const url = new URL(this.supportUrl);
            if (this.user) {
                url.searchParams.set('firstname', this.user.first_name);
                url.searchParams.set('lastname', this.user.last_name);
                url.searchParams.set('email', this.user.email);
            }
            url.searchParams.set('support_company_name', this.site.name);
            url.searchParams.set('venngo_session_info', JSON.stringify(this.browser));
            this.supportUrl = url;
        },
        handleKeyDown(event) {
            if (event.key === 'Escape') {
                this.isUserWidgetOpen && this.closeUserWidget();
                this.isMobileMenuOpen && this.toggleMobileMenu();
            }
        }
    },
    components: {
        'perk-search': PerkSearch,
        'notification': Notification,
        'horizontal-list': HorizontalList,
    },
    directives: {
        'click-outside': clickOutside,
    }
});
